import React from "react";
import cookie from "react-cookies";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { isUserLoggedIn } from "./../../service/action/audio-track-action";
import "./login.css";
import Alert from "@material-ui/lab/Alert";
import { spacing } from "@material-ui/system";
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      errormessage: "",
    };
  }

  componentDidMount() {
    if (cookie.load("username")) {
      this.props.history.push("/dashboard");
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userLogin.loggedUser.isVerified) {
      this.props.history.push("/dashboard");
    } else {
      if (nextProps.userLogin.error.message != "") {
        this.setState({ errormessage: nextProps.userLogin.error.message });
      }
    }
  }

  render() {
    const { userName, password, errormessage } = this.state;
    return (
      <div className="login-page">
        <div className="containerHolder">
          <form
            onSubmit={(e) => [
              e.preventDefault(),
              this.props.isUserLoggedIn(userName, password),
            ]}
            className="container"
          >
            <h1>Login</h1>
            {errormessage != "" ? (
              <Alert severity="warning">{errormessage}</Alert>
            ) : null}
            <div>
              <TextField
                id="standard-basic"
                autoComplete="nope"
                label="User Name"
                onChange={(e) => this.setState({ userName: e.target.value })}
                value={userName}
              />
            </div>
            <div>
              <TextField
                type="password"
                autoComplete="new-password"
                id="standard-basic"
                label="Password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </div>

            <div className="login-btn-wrapper">
              <Button
                type="submit"
                disabled={
                  password.length >= 1 && userName.length >= 1 ? false : true
                }
                //  onClick={() => this.props.history.push("/dashboard")}
                variant="contained"
                color="primary"
                disableElevation
              >
                Login
              </Button>
            </div>
            <br />
            <br />
            <div style={{ textAlign: "right" }}>
              <a href="/register"> Click Here to Register</a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { AudioToTrackReducer, userLogin } = state;
  return {
    AudioToTrackReducer,
    userLogin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  isUserLoggedIn: (username, password) =>
    dispatch(isUserLoggedIn(username, password)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
